document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("region-popup");
  const langBtn = document.querySelector(".as-lang");
  if (!popup) return;

  const closeEls = popup.querySelectorAll("[data-region-close]");
  const confirmBtn = popup.querySelector(".btn-confirm");

  if (!localStorage.getItem("regionPopupShown")) {
    setTimeout(() => { popup.style.display = "flex"; }, 3000);
  }

  if (langBtn) {
    langBtn.addEventListener("click", e => {
      e.preventDefault();
      popup.style.display = "flex";
    });
  }

  closeEls.forEach(el => el.addEventListener("click", () => {
    popup.style.display = "none";
  }));

  document.querySelectorAll(".disclosure[data-select]").forEach(select => {
    const summary = select.querySelector("summary");
    const labelEl = summary.querySelector(".lang-label") || summary; 
    const flagImg = summary.querySelector(".lang-flag img");   
    const type = select.dataset.select; 
    const hiddenInput = document.querySelector(`input[name='${type}_code']`);

    select.querySelectorAll("button[data-value]").forEach(btn => {
      btn.addEventListener("click", () => {
        hiddenInput.value = btn.dataset.value;

        labelEl.textContent = btn.dataset.label;


        if (flagImg && btn.dataset.flagSrc) {
          flagImg.src = btn.dataset.flagSrc;  
          flagImg.alt = `${btn.dataset.label} flag`;
        }

        select.removeAttribute("open");

        select.querySelectorAll(".custom-select-item").forEach(li => li.classList.remove("active"));
        btn.closest(".custom-select-item").classList.add("active");
      });
    });
  });

  if (confirmBtn) {
    confirmBtn.addEventListener("click", () => {
      localStorage.setItem("regionPopupShown", "true");
    });
  }
});


